


export const SESSION_KEY_ADVERT = "p-advert";
export const COOKIE_NAME_TRACKING = "p-tracking";